module.exports = __webpack_public_path__ + "img/unfold-icon-5.19fed98e.png";